import React from 'react';

//components
import BreadCrumb from 'src/components/common/modules/breadcrumb/breadcrumb';

//helpers
import { checkValue , capitalizeFirst } from 'src/components/common/helper';

//types
import { HeroBreadcrumbProps } from '../../typings';
import { BreadCrumbProps } from 'src/components/common/module-util';

const HeroBreadcrumb: React.FC<HeroBreadcrumbProps> = (props) => {
  const { partner, templateName, feedName, mccidData, breadcrumbHomeCopy, breadcrumbHomeUrl,breadcrumbParentCopy, breadcrumbParentUrl, isMiddleLayerEnabled, breadcrumbCurrentCopy } = props;
  
  //if spotlight main page , hide the breadcrumbs
  if (checkValue(partner) && partner.toLowerCase() === 'spotlight') {
    return null;
  }

  const mcicdTrackings: BreadCrumbProps['expTracking'] = {
    templateType: checkValue(mccidData.templateType) ? mccidData.templateType : '',
    campaignUrl: checkValue(mccidData.campaignUrl) ? mccidData.campaignUrl : '',
    mainUrl: checkValue(mccidData.mainUrl) ? mccidData.mainUrl : '',
    referrerId: checkValue(mccidData.referrerId) ? mccidData.referrerId : '',
  };

  const crumbs: BreadCrumbProps['BreadCrumbs'] = [
    {
      DisplayName: checkValue(breadcrumbCurrentCopy) ? breadcrumbCurrentCopy :  capitalizeFirst(feedName),
      Value: partner + '/' + templateName + '/' + feedName,
    },
  ];

  return (
    <div className="hero-breadcumb-component">
      <BreadCrumb
        homeHref={checkValue(breadcrumbHomeUrl) ? breadcrumbHomeUrl : partner + '/' + templateName}
        homeLoc={checkValue(breadcrumbHomeCopy) ? breadcrumbHomeCopy : 'Home'}
        BreadCrumbs={...crumbs}
        expTracking={mcicdTrackings}
        middleLayerCopy={checkValue(breadcrumbParentCopy)?breadcrumbParentCopy:''}
        middleLayerUrl={checkValue(breadcrumbParentUrl)?breadcrumbParentUrl:''}
        isMiddleLayerEnable={checkValue(isMiddleLayerEnabled)?isMiddleLayerEnabled:"false"}
      />
    </div>
  );
};

export default HeroBreadcrumb;
